class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.searchButton = this.querySelector('button[type="submit"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    if (this.searchButton) {
      this.searchButton.addEventListener('click', this.onSearchClick.bind(this));
    }
  }

  onSearchClick(event) {
    // Prevent the default form submission for demonstration
    event.preventDefault();
    console.log('Search initiated:', this.input.value);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onFormReset() {
    this.toggleResetButton();
  }

  onChange(event) {
    this.toggleResetButton();
  }
}

customElements.define('search-form', SearchForm);

// Utility function for debouncing
function debounce(callback, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(this, args), delay);
  };
}